export default {
    name: 'Vardas',
    tel: 'Telefonas',
    save: 'Išsaugoti',
    confirm: 'Patvirtinti',
    cancel: 'Atšaukti',
    delete: 'Ištrinti',
    complete: 'Užbaigti',
    loading: 'Kraunama...',
    telEmpty: 'Prašome įvesti telefono numerį',
    nameEmpty: 'Prašome įvesti vardą',
    nameInvalid: 'Netinkamas vardo formatas',
    confirmDelete: 'Ar tikrai norite ištrinti?',
    telInvalid: 'Netinkamas telefono numerio formatas',
    vanCalendar: {
        end: 'Pabaiga',
        start: 'Pradžia',
        title: 'Kalendorius',
        startEnd: 'Pradžia/Pabaiga',
        weekdays: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Pasirinkite ne daugiau kaip ${maxRange} dienų`,
    },
    vanCascader: {
        select: 'Pasirinkti',
    },
    vanContactCard: {
        addText: 'Pridėti kontaktinę informaciją',
    },
    vanContactList: {
        addText: 'Pridėti naują kontaktą',
    },
    vanPagination: {
        prev: 'Ankstesnis',
        next: 'Kitas',
    },
    vanPullRefresh: {
        pulling: 'Patraukite atnaujinimui...',
        loosing: 'Paleiskite atnaujinimui...',
    },
    vanSubmitBar: {
        label: 'Iš viso:',
    },
    vanCoupon: {
        unlimited: 'Neribota',
        discount: (discount) => `${discount * 10}% nuolaida`,
        condition: (condition) => `Mažiausiai ${condition}`,
    },
    vanCouponCell: {
        title: 'Kuponas',
        tips: 'Nėra kuponų',
        count: (count) => `Turite ${count} kupon${count % 10 === 1 && count % 100 !== 11 ? 'ą' : 'ų'}`,
    },
    vanCouponList: {
        empty: 'Nėra kuponų',
        exchange: 'Apsikeisti',
        close: 'Uždaryti',
        enable: 'Galima naudoti',
        disabled: 'Negalima naudoti',
        placeholder: 'Kupono kodas',
    },
    vanAddressEdit: {
        area: 'Regionas',
        postal: 'Pašto kodas',
        areaEmpty: 'Prašome pasirinkti pristatymo regioną',
        addressEmpty: 'Adresas negali būti tuščias',
        postalEmpty: 'Neteisingas pašto kodas',
        defaultAddress: 'Nustatyti kaip numatytąjį adresą',
        telPlaceholder: 'Telefonas',
        namePlaceholder: 'Vardas',
        areaPlaceholder: 'Regionas',
    },
    vanAddressEditDetail: {
        label: 'Adresas',
        placeholder: 'Adresas',
    },
    vanAddressList: {
        add: 'Pridėti naują adresą',
    },
};